<div class="shared-container">
  <app-modal-mensagem
    *ngIf="mensagemErro"
    tipo="erro"
    titulo="Não foi possível criar a tarefa"
    [mensagem]="mensagemErro"
    (confirmar)="fecharErro()"
  ></app-modal-mensagem>
  <app-sucesso
    *ngIf="tarefaCriadaSucesso"
    [mensagem]="'Tarefa agendada com sucesso!'"
    (continuar)="fecharSucesso()"
  />
  <div *ngIf="!tarefaCriadaSucesso">
    <div *ngIf="contatoInfo" class="contato-info">
      <div class="titulo-cargo">{{ contatoInfo.cargo }}</div>
      <div class="nome-contato">{{ contatoInfo.nome }}</div>
      <div class="email-contato">{{ contatoInfo.email }}</div>
    </div>

    <div class="form-content">
      <label for="taskDescription">Descreva a Tarefa</label>
      <textarea
        id="taskDescription"
        [(ngModel)]="description"
        class="form-control textarea-agenda"
        placeholder="Descreva a tarefa..."
      ></textarea>

      <label for="responsavel">Responsável</label>
      <select
        id="responsavel"
        [(ngModel)]="responsibleID"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !responsibleID }"
      >
        <option value="" disabled>Selecione o responsável</option>
        <option *ngFor="let r of responsavel" [value]="r.id">
          {{ r.name }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !responsibleID"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <label for="tarefa">Selecionar Tarefa</label>
      <select
        id="tarefa"
        [(ngModel)]="actionID"
        class="form-control"
        [ngClass]="{ 'is-invalid': campoObrigatorioErro && !actionID }"
      >
        <option value="" disabled>Selecione a tarefa</option>
        <option *ngFor="let r of tarefas" [value]="r.id">
          {{ r.description }}
        </option>
      </select>
      <div
        *ngIf="campoObrigatorioErro && !actionID"
        class="campo-obrigatorio-msg"
      >
        Campo obrigatório!
      </div>

      <div class="date-time">
        <div>
          <label for="data">Data</label>
          <input
            id="data"
            type="date"
            [(ngModel)]="data"
            class="form-control"
            [min]="today"
            [ngClass]="{ 'is-invalid': campoObrigatorioErro && !data }"
          />
          <div *ngIf="campoObrigatorioErro && !data" class="campo-obrigatorio-msg">
            Campo obrigatório!
          </div>
        </div>
        <div>
          <label for="hora">Hora</label>
          <input
            id="hora"
            type="time"
            [(ngModel)]="hora"
            class="form-control"
            [ngClass]="{ 'is-invalid': campoObrigatorioErro && !hora }"
          />
          <div *ngIf="campoObrigatorioErro && !hora" class="campo-obrigatorio-msg">
            Campo obrigatório!
          </div>
        </div>
      </div>
    </div>

    <div class="footer-actions">
      <button class="btn btn-secondary" type="button" (click)="limparCampos()">
        Limpar Dados
      </button>
      <button class="btn btn-primary" type="button" (click)="criarTarefa()">
        Agendar Tarefa
      </button>
    </div>
  </div>
</div>
